import "../../assets/css/views/userManagement/usersManagementMassive.css";
import { useTranslation } from "react-i18next";
import {
  Button,
  FilePicker,
  Group,
  IconHelp,
  Modal,
  Select,
} from "@veneer/core";
import Loader from "../../components/Loader/loader";
import LoaderModal from "../../components/Loader/loaderModal";
import { useUsersManagementMassive } from "../../hooks/userManagement/useUsersManagementMassive";
import { ModalMessageUser } from "./UserComponent/ModalMessageUser";

export default function UsersManagementMassive() {
  const [t] = useTranslation("global");
  const { 
      optionsTypeAction,
      actionTypeSelected,
      setActionTypeSelected,
      handleCreateUsers,
      setOpenModalHelp,
      openModalHelp,
      loading,
      disabledDownloadTemplate,
      handleDownloadTemplate,
      loadingModal,
      openModalCreate,
      handleOnClickExit,
      buttonSaveDisabled,
      fileName,
      errorFilePicker,
      messageError,
      handleFileChange,
      submitUsers,
      onClearFilePicker,
      openModalCreateDone,
      openModalError,
      setOpenModalCreateDone,
      setOpenModalError
    } = useUsersManagementMassive();

  return (
    <div className="users-management-massive-container">
      {loading && <Loader />}
      <h4 className="users-management-massive-title">
        {t("header.usersManagementMassiveTitle")}
      </h4>

      <div className="users-management-massive-buttons">
        <div>
          <Button onClick={handleCreateUsers} style={{ margin: "5px" }}>
            {t("header.uploadFile")}
          </Button>

          <div className="tooltip">
            <span className="tooltiptext">
              {t("modal.titleHelper").replace(":", "?")}
            </span>
            <Button
              style={{ margin: "5px" }}
              appearance="secondary"
              leadingIcon={<IconHelp />}
              onClick={() => setOpenModalHelp(true)}
            ></Button>
          </div>

        </div>

        <div className="users-management-massive-buttons-right">
          <Select
            className="users-management-massive-buttons-select"
            label={t("header.selectTypeAction")}
            options={optionsTypeAction}
            value={actionTypeSelected}
            onChange={e => setActionTypeSelected([e.value])}
            onClear={() => setActionTypeSelected([])}
            placement="bottom-start"
          />

          <Button disabled={disabledDownloadTemplate} onClick={handleDownloadTemplate} style={{ margin: "5px" }}>
            {t("header.downloadTemplate")}
          </Button>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageUser
          openModal={openModalHelp}
          setOpenCloseModal={setOpenModalHelp}
          closeModalCreateUser={() => setOpenModalHelp(false)}
          title={t("modal.titleHelper")}
          message={t("modal.helperUsersMassive")}
        />
      </div>

      {loadingModal && <LoaderModal />}

      <div style={{ position: "relative" }}>
        <Modal
          align="center"
          closeButton
          id="modal-Create"
          show={openModalCreate}
          onClose={handleOnClickExit}
          footer={
            <div className="buttonGroup">
              <Group>
                <Button appearance="secondary" onClick={handleOnClickExit}>
                  {t("header.closebutton")}
                </Button>
                <Button onClick={submitUsers} disabled={buttonSaveDisabled}>
                  {t("header.sendButton")}
                </Button>
              </Group>
            </div>
          }
          title={t("modal.manageUsersMassive")}
        >
          <div>
            <h5>{t("header.uploadFile")}</h5>
            <FilePicker
              className="modalSellOutFile"
              id="selOut-file-picker"
              label={t("header.uploadFile")}
              accept=".xlsx"
              onChange={handleFileChange}
              onClear={onClearFilePicker}
              value={fileName}
              error={errorFilePicker}
              helperText={messageError}
            />
          </div>
        </Modal>
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageUser
          openModal={openModalCreateDone}
          closeModalCreateUser={() => setOpenModalCreateDone(false)}
          title={t("modal.message")}
          message={t("modal.messageUsers")}
        />
      </div>

      <div style={{ position: "relative" }}>
        <ModalMessageUser
          openModal={openModalError}
          closeModalCreateUser={() => setOpenModalError(false)}
          title={t("header.error")}
          message={t("modal.generalError")}
        />
      </div>
    </div>
  );
}
